import { render } from "./ChamadosView.vue?vue&type=template&id=3067660f&scoped=true"
import script from "./ChamadosView.vue?vue&type=script&lang=js"
export * from "./ChamadosView.vue?vue&type=script&lang=js"

import "./ChamadosView.vue?vue&type=style&index=0&id=3067660f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3067660f"]])

export default __exports__